<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :md="24" :sm="24">
        <a-button type="primary" @click="handleAddTopology">{{ $t('新增项目') }}</a-button>
      </a-col>
    </a-row>
    <br/>
    <a-row :gutter="24">
      <a-col :md="24" :sm="24">
        <a-collapse>
          <a-collapse-panel :header="`${item.name}【${item.code}】`" v-for="item in list" :key="item.code">
            <div>
              <a-table
                :columns="columns"
                :data-source="item.topologyList"
                :pagination="false"
                :loading="loading"
                rowKey="id"
                :scroll="{ x: 1500 }"
                size="middle"
              >
                <template slot="action" slot-scope="text, record">
                  <a @click="handleDetail(record)">{{ $t('查看') }}</a>
                  <a-divider type="vertical" />
                  <a @click="handleEdit(record)" >{{ $t('编辑') }}</a>
                  <a-divider type="vertical" />
                  <a-popconfirm :title="$t('确定启用吗?')" @confirm="() => handleStart(record)">
                      <a :disabled="record.ifUsed == 1">{{ $t('启用') }}</a>
                  </a-popconfirm>
                  <a-divider type="vertical" />
                  <a @click="handleEditTopology(record)" :disabled="record.type == 'TOPOLOGY_TYPE_BASE'||record.ifUsed==1">{{ $t('编辑拓扑') }}</a>
                </template>
              </a-table>
            </div>
            <div slot="extra">
                <a @click.stop="handleEditProject(item)" style="margin-right: 10px;"><a-icon type="edit" /> {{ $t('编辑项目') }}</a>
                <a @click.stop="handleAddVersion(item)"><a-icon type="plus-circle" /> {{ $t('新增拓扑') }}</a>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>
    <AddProjectModal ref="AddProjectModalRef" @ok="callback" />
    <AddTopologyModal ref="AddTopologyModalRef" @ok="callback" />
  </a-card>
</template>
  
<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { httpAction, getAction, postAction } from '@/api/manage'
import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
import AddProjectModal from './components/AddProjectModal.vue'
import AddTopologyModal from './components/AddTopologyModal.vue'

export default {
  name: 'PipelineVersionManagement',
  components: {
    AddProjectModal,
    AddTopologyModal,
  },
  data() {
    return {
      url: {
        listProjectTopology: '/jeecg-gis/topology/topology/listProjectTopology',
        useTopology: "/jeecg-gis/topology/topology/useTopology"
      },
      list: [],
      loading: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('拓扑代码'),
          dataIndex: 'code',
          align: 'center',
          //   width: 120,
          ellipsis: true,
        },
        {
          title: this.$t('名称'),
          dataIndex: 'name',
          align: 'center',
          //   width: 120,
          ellipsis: true,
        },
        {
          title: this.$t('创建人'),
          dataIndex: 'createBy',
          align: 'center',
          //   width: 120,
          ellipsis: true,
        },
        {
          title: this.$t('创建日期'),
          dataIndex: 'createTime',
          align: 'center',
          //   width: 120,
          ellipsis: true,
        },
        {
          title: this.$t('更新日期'),
          dataIndex: 'updateTime',
          align: 'center',
          //   width: 120,
          ellipsis: true,
        },
        {
          title: this.$t('是否启用'),
          dataIndex: 'ifUsed',
          align: 'center',
          customRender: (text) => {
            if (text == 0) {
              return this.$t('未启用')
            } else if (text == 1) {
              return this.$t('已启用')
            }
          },
          //   width: 120,
          ellipsis: true,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'action',
          align: 'center',
          width: 220,
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  watch: {},
  methods: {
    init() {
      postAction(this.url.listProjectTopology).then(res => {
        if (res.success) {
          this.list = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 新增项目
    handleAddTopology() {
        this.$refs.AddProjectModalRef.init({});
    },
    handleEditProject(record){
      this.$refs.AddProjectModalRef.init(record);
    },
    // 新增拓扑
    handleAddVersion(record){
        this.$refs.AddTopologyModalRef.init(record);
    },
    handleDetail(record) {
        this.$router.push({
            path: '/DMAPartitionMetering/PipelineNetMap/PipeNetwork/PipeNetworkEditing',
            query: {
              arg: JSON.stringify({ ...record,disabled: true })
            }
        })
    },
    handleEdit(record) {
        this.$router.push({
            path: '/DMAPartitionMetering/PipelineNetMap/PipeNetwork/PipeNetworkEditing',
            query: {
              arg: JSON.stringify({ ...record,disabled: false })
            }
        })
    },
    handleStart(record) {
        postAction(this.url.useTopology,{code: record.code}).then(res=>{
            if(res.success){
                this.$message.success(this.$t('启用成功！'));
                this.init();
            }else{
                this.$message.error(res.message);
            }
        })
    },
    callback(){
        this.init();
    },
    handleEditTopology(record){
      this.$refs.AddTopologyModalRef.init(record);
    }
  },
}
</script>
  <style scoped>
@import '~@assets/less/common.less';
</style>